import { render, staticRenderFns } from "./stage2.vue?vue&type=template&id=2c1203e4&scoped=true"
import script from "./stage2.vue?vue&type=script&lang=js"
export * from "./stage2.vue?vue&type=script&lang=js"
import style0 from "./stage2.vue?vue&type=style&index=0&id=2c1203e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1203e4",
  null
  
)

export default component.exports